export default __webpack_public_path__ + "static/media/MEBL.b57fd1c8.png";